/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ order: NonNullable<unknown>, lines: NonNullable<unknown>, gap: NonNullable<unknown> }} Einvoice_Stuck_DriftInputs */

const vi_einvoice_stuck_drift = /** @type {(inputs: Einvoice_Stuck_DriftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tổng đơn ${i?.order} khác tiền hàng + VAT ${i?.lines}, lệch ${i?.gap}. Báo quản trị để sửa tổng tiền.`)
};

/**

* @param {Einvoice_Stuck_DriftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stuck_drift = /** @type {((inputs: Einvoice_Stuck_DriftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Stuck_DriftInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stuck_drift(inputs)
});